import { styled } from '@mui/material/styles'

import LinkButton from 'src/components/LinkButton/LinkButton'

export const SendPhoneResetEmail = styled(LinkButton)(({ theme }) => ({
  alignSelf: 'flex-end',
  marginBottom: theme.spacing(1),
}))
